const RUN_STATUS_LABELS = Object.freeze({
  queued: 'AI 项目经理已排队',
  running: 'AI 项目经理正在分析',
  waiting_retry: 'AI 项目经理正在自动恢复',
  succeeded: '分析已完成',
  failed: '部分步骤未完成',
  cancelled: '分析已停止',
})

const STAGE_STATUS_LABELS = Object.freeze({
  pending: '等待前序结果',
  queued: '已排队',
  running: '正在处理',
  waiting_retry: '正在自动恢复',
  succeeded: '已完成',
  failed: '暂未完成',
  skipped: '本轮无需处理',
})

const CONNECTION_STATE_LABELS = Object.freeze({
  idle: '等待下一步',
  connecting: '正在连接云端进度',
  connected: '云端进度已连接',
  reconnecting: '正在恢复云端进度',
  closed: '进度连接已结束',
})

const PUBLIC_ERROR_PREFIXES = Object.freeze([
  'EXTERNAL_RESEARCH_', 'RESEARCH_', 'REPORT_', 'PROJECT_', 'ANALYSIS_',
])

export function runStatusLabel(status) {
  return RUN_STATUS_LABELS[String(status || '')] || '正在确认状态'
}

export function reportDeliveryLabel(run) {
  const progress = run?.progress_summary || {}
  if (progress.delivery_ready) return '分析完成，报告和 PDF 已准备好'
  const stage = run?.current_stage
  if (stage === 'report_generation') {
    const count = Math.max(0, Math.min(12, Number(progress.completed_chapters || 0)))
    return `${progress.is_recovering ? '正在校验和完善报告' : '正在生成报告'}，已完成 ${count} / 12 章`
  }
  if (stage === 'report_persist') return '正在保存完整报告'
  if (stage === 'pdf_render') return '报告已生成，正在准备 PDF'
  return ''
}

export function stageStatusLabel(status) {
  return STAGE_STATUS_LABELS[String(status || '')] || '正在确认'
}

export function connectionStateLabel(state) {
  return CONNECTION_STATE_LABELS[String(state || '')] || '正在确认云端进度'
}

export function safeStageErrorMessage(stage) {
  const code = String(stage?.error_code || '')
  const message = String(stage?.error_message || '').trim()
  const isPublicCode = PUBLIC_ERROR_PREFIXES.some((prefix) => code.startsWith(prefix))
  return isPublicCode && message ? message : '该步骤暂未完成，已完成结果已保留。'
}

export function marketAnalysisFailure(run) {
  const code = String(run?.failure_code || '')
  const message = String(run?.failure_message || '').trim()
  const isPublicCode = PUBLIC_ERROR_PREFIXES.some((prefix) => code.startsWith(prefix))
  if (isPublicCode && message) return message
  const failedStage = Array.isArray(run?.stages) ? run.stages.find((stage) => stage?.status === 'failed') : null
  return failedStage
    ? safeStageErrorMessage(failedStage)
    : 'AI 项目经理暂时未能完成本次分析，企业资料和已完成结果已保留。'
}

export function marketAnalysisRecovery(run) {
  const capability = run?.recovery || {}
  if (capability.can_resume !== true) {
    return { canResume: false, actionLabel: '', pendingLabel: '' }
  }
  const failedCount = Math.max(1, Number(capability.failed_count || 1))
  if (capability.scope === 'report') {
    return {
      canResume: true,
      actionLabel: '继续完成分析',
      pendingLabel: 'AI 项目经理正在继续生成未完成报告，已完成研究不会重复处理。',
    }
  }
  if (capability.scope === 'research') {
    return {
      canResume: true,
      actionLabel: '继续完成分析',
      pendingLabel: `AI 项目经理正在继续 ${failedCount} 个未完成平台，已完成结果不会重复处理。`,
    }
  }
  return { canResume: false, actionLabel: '', pendingLabel: '' }
}
